module.exports = __webpack_public_path__ + "static/media/pool.ed6ff2ae.jpg";